import Linkify from "linkify-react";
import React from "react";
import { Link } from "react-router-dom";

interface LinkCreatorProps {
  line: string;
}

const LinkCreator = React.memo(function LinkCreator(props: LinkCreatorProps) {
  // Ensure we have a string to render
  const content = typeof props.line === 'string' ? props.line : '';
  return (
    <Linkify
      options={{
        render: {
          url: ({ attributes, content }) => {
            return (
              <a {...attributes} target="_blank">
                {content}
              </a>
            );
          },
          mention: ({ attributes, content }) => {
            const { href, ...props } = attributes;
            return (
              <Link to={href} {...props}>
                {content}
              </Link>
            );
          },
        },
      }}
    >
      {content}
    </Linkify>
  );
});

export default LinkCreator;
